import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentApplicationVersion = environment.appVersion;
  today: number = Date.now();

  constructor() { }

  ngOnInit(): void {
  }

}
